import {getFeatureFlags, SessionStorage} from '@chekin/core';
import {STORAGE_KEYS} from 'utils/constants';

export const setIVIntentRemoteSession = (intentId: string) => {
  SessionStorage.set(STORAGE_KEYS.ivIntentRemoteSession, intentId);
};

export const getIVIntentRemoteSession = (): string | null =>
  getFeatureFlags('IVCO_49_MOVE_IV_TO_MOBILE')
    ? SessionStorage.get(STORAGE_KEYS.ivIntentRemoteSession)
    : null;

export const removeIVIntentRemoteSession = () =>
  SessionStorage.remove(STORAGE_KEYS.ivIntentRemoteSession);
